var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('div',{staticClass:"control"},[_c('label',{staticClass:"label"},[_vm._v(_vm._s(_vm.elLabel))]),_vm._v(" "),_c('vue-editor',{attrs:{"editorToolbar":_vm.customToolbar},model:{value:(_vm.n),callback:function ($$v) {_vm.n=$$v},expression:"n"}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d166691","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cms/elements/HTML.vue
// module id = 632
// module chunks = 0